import FeedManagement from "./FeedManagement";

export default FeedManagement;
